import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('waya-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('waya-cookie-consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="waya-cookie-nav">
      <div className="waya-cookie-nav-container">
        <div className="waya-cookie-nav-left">
          <span className="waya-cookie-nav-emoji">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
              <path d="M8.5 8.5v.01" /><path d="M16 15.5v.01" /><path d="M12 12v.01" /><path d="M11 17v.01" /><path d="M7 14v.01" />
            </svg>
          </span>
          <p className="waya-cookie-nav-text">
            We use cookies to improve your experience. By using our site, you agree to our <a href="/privacy-policy">Cookie Policy</a>.
          </p>
        </div>
        <div className="waya-cookie-nav-right">
          <button className="waya-cookie-nav-btn" onClick={handleAccept}>
            Accept Cookies
          </button>
          <button className="waya-cookie-nav-close" onClick={handleAccept} title="Close">
            ✕
          </button>
        </div>
      </div>
      <style jsx>{`
        .waya-cookie-nav {
          width: 100%;
          background: #0f172a; /* Sleek dark slate */
          color: white;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          position: fixed;
          bottom: 0;
          left: 0;
          z-index: 99999;
          animation: slideUpFade 0.5s cubic-bezier(0.16, 1, 0.3, 1);
        }

        @keyframes slideUpFade {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        .waya-cookie-nav-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 8px 4%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 44px;
        }

        .waya-cookie-nav-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .waya-cookie-nav-emoji {
          font-size: 14px;
        }

        .waya-cookie-nav-text {
          margin: 0;
          font-size: 13px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
          letter-spacing: -0.01em;
        }

        .waya-cookie-nav-text a {
          color: white;
          text-decoration: underline;
          font-weight: 500;
          margin-left: 4px;
        }

        .waya-cookie-nav-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .waya-cookie-nav-btn {
          background: #FF4400;
          color: white;
          border: none;
          padding: 6px 16px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .waya-cookie-nav-btn:hover {
          background: #ff5511;
          transform: translateY(-1px);
        }

        .waya-cookie-nav-close {
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.5);
          font-size: 16px;
          cursor: pointer;
          padding: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.2s ease;
        }

        .waya-cookie-nav-close:hover {
          color: white;
        }

        @media (max-width: 768px) {
          .waya-cookie-nav-container {
            flex-direction: column;
            padding: 12px 4%;
            gap: 12px;
            text-align: center;
          }
          .waya-cookie-nav-right {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
